/* eslint-disable no-underscore-dangle */
import Cookie from './cookie';

const login = {
  _uin: '',
  _csrfCode: '',

  init() {
    this.updateUin();
    this.updateCsrfCode();
    return this;
  },

  getUin() {
    this.updateUin();
    return this._uin;
  },

  getCsrfCode() {
    this.updateCsrfCode();
    return this._csrfCode;
  },

  updateUin() {
    const uin = Cookie.get('uin') || '';
    this._uin = uin.replace(/^o0*/, '');
  },

  updateCsrfCode() {
    const skey = Cookie.get('skey') || Cookie.get('p_skey');

    if (!skey) {
      this._csrfCode = '';
    } else {
      let hash = 5381;

      for (let i = 0, len = skey.length; i < len; i += 1) {
        hash += (hash << 5) + skey.charCodeAt(i);
      }

      this._csrfCode = hash & 0x7fffffff;
    }
  },
};

export default login.init();
